<template>
  <v-card>
    <v-window touchless show-arrows v-model="currentPhoto" next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left">
      <v-window-item ref="zoomableImage" v-for="(photo, i) in photos" :key="photo.id" :value="i">
        <div :class="`d-flex justify-center ${zoomed ? 'grabbable' : ''}`" style="object-fit: contain; width: 100%; height: 100%;">
          <img class="zoomable" @dragstart.prevent @dragenter.prevent @dragend.prevent :src="getSignedUrl ? getSignedUrl(photo.photoUrl) : photo.photoUrl" style="max-height: 500px; max-width: 500px;" />
        </div>
      </v-window-item>
    </v-window>
  </v-card>
</template>

<script>
import Panzoom from '@panzoom/panzoom';

export default {
  name: 'EsAssetZoom',
  props: {
    photos: {
      type: Array,
      required: true,
      default: () => ([]),
    },
    selectedPhoto: {
      type: Number,
      default: 0,
    },
    getSignedUrl: {
      type: Function,
      required: false,
    },
  },
  data: () => ({
    zoomed: false,
    z: [],
    currentPhoto: 0,
  }),
  mounted() {
    this.z = this.$refs.zoomableImage;
    this.currentPhoto = this.selectedPhoto;
  },
  watch: {
    z: {
      handler() {
        const picContainers = document.getElementsByClassName('zoomable') || [];
        Array.from(picContainers).forEach((el) => {
          const panzoom = Panzoom(el, {
            startScale: 1,
            minScale: 1,
            maxScale: 5,
            zoomSpeed: 0.065,
          });
          el.addEventListener('mousewheel', (e) => {
            e.preventDefault();
            panzoom.zoomWithWheel(e);
          });
          el.addEventListener('panzoomchange', (event) => {
            const { scale } = event.detail;
            if (scale === 1) {
              panzoom.pan(0, 0);
            }
          });
          let timeout;
          let lastTap = 0;
          el.addEventListener('click', (event) => {
            const currentTime = new Date().getTime();
            const tapLength = currentTime - lastTap;
            clearTimeout(timeout);
            if (tapLength < 500 && tapLength > 0) {
              panzoom.zoom(panzoom.getScale() + 1);
              event.preventDefault();
            } else {
              timeout = setTimeout(() => {
                clearTimeout(timeout);
              }, 500);
            }
            lastTap = currentTime;
          });
        });
      },
      immediate: true,
    },
  },
}
</script>
